var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clazz)?_c('div',{staticClass:"cycle_rule"},[(_vm.clazz.clazz_type==1)?_c('cycle-run-rule',{attrs:{"clazz":_vm.clazz}}):_vm._e(),(_vm.clazz.clazz_type==2)?_c('cycle-cutting-rule',{attrs:{"clazz":_vm.clazz}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }